import React from "react";

function handleSubmit(e) {
  e.preventDefault();
  console.log("You clicked submit.");
}

// const handleChange = (event) => {
//   const value = event.target.value;
//   setState({
//     ...state,
//     [event.target.name]: value,
//   });
// };

function Subs() {
  return (
    <>
      <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
        <div className="w-lg-500px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto">
          <h1> Start Your Premimum Plus 30-day free trial with this book </h1>
          <h3> Add Card </h3>
          <p> We Accept All Major Credit </p>
          <form className="form w-100" onSubmit={handleSubmit}>
            <label className="form-label fs-6 fw-bolder text-dark">
              Credit Card Number
            </label>
            <input
              className="form-control form-control-lg form-control-solid"
              type="text"
              name="creditcard"
              id="creditcard"
              placeholder="Credit Card Number"
            />
            <label className="form-label fs-6 fw-bolder text-dark">
              Expiration Date
            </label>
            <select name="months" id="months">
              <option value="volvo">Jan</option>
              <option value="saab">Feb</option>
              <option value="mercedes">Mar</option>
            </select>
            <select name="years" id="years">
              <option value="volvo">2022</option>
              <option value="saab">2023</option>
              <option value="mercedes">2024</option>
              <option value="audi">2025</option>
            </select>
            <label className="form-label fs-6 fw-bolder text-dark">
              Full Name
            </label>
            <input
              className="form-control form-control-lg form-control-solid"
              type="text"
              name="fname"
              id="fname"
              placeholder="Full Name"
            />
            <label className="form-label fs-6 fw-bolder text-dark">
              Country
            </label>
            <input
              className="form-control form-control-lg form-control-solid"
              type="text"
              name="country"
              id="country"
              placeholder="Country"
            />
            <label className="form-label fs-6 fw-bolder text-dark">
              Address Line 1
            </label>
            <input
              className="form-control form-control-lg form-control-solid"
              type="text"
              name="address1"
              id="address1"
              placeholder="Address 1"
            />
            <label className="form-label fs-6 fw-bolder text-dark">
              Address Line 2
            </label>
            <input
              className="form-control form-control-lg form-control-solid"
              type="text"
              name="address2"
              id="address2"
              placeholder="Address 2"
            />
            <label className="form-label fs-6 fw-bolder text-dark">
              Zip Code{" "}
            </label>
            <input
              className="form-control form-control-lg form-control-solid"
              type="text"
              name="zipcode"
              id="zipcode"
              placeholder="Zip Code"
            />
            <label className="form-label fs-6 fw-bolder text-dark">State</label>
            <select name="stateval" id="stateval">
              <option value="volvo">Arizona</option>
              <option value="saab">Arizona</option>
              <option value="mercedes">Arizona</option>
              <option value="audi">Arizona</option>
            </select>
            <label className="form-label fs-6 fw-bolder text-dark">City</label>
            <input
              className="form-control form-control-lg form-control-solid"
              type="text"
              name="city"
              id="city"
              placeholder="City"
            />
            <p>
              Order Total: <b>$0.00</b>
            </p>
            <button type="submit" className="btn btn-lg btn-primary w-100 mb-5">
              <span className="indicator-label">Try for $0.00</span>
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default Subs;
